





















import { defineComponent, ref, computed } from '@vue/composition-api';

export default defineComponent({
    name: 'loading',
    props: {
        show: {
            type: Boolean,
            default: undefined,
        },
        showMask: {
            type: Boolean,
            default: false,
        },
        color: {
            type: String,
            default: '#712634',
        },
    },
    setup(props) {
        const flag = ref(false); // 通过prototype方法控制
        // 通过props控制
        const fromProps = computed(() => {
            return props.show !== undefined;
        });
        return {
            flag,
            fromProps,
        };
    },
});
